// The CTA ladder above the footer (ocl_online#170): which columns show, and
// which one gets the filled button. No imports, so the unit tests run in bare
// Node, like earlyAccess.js.
// docs/superpowers/specs/2026-09-27-cta-ladder-design.md

// L2: one order on every page.
export const LADDER_ORDER = ['signup', 'newsletter', 'call', 'pro'];

const segments = pathname => pathname.split('/').filter(Boolean);

// A /tools/<tool> page ends with a Get started block that already links to
// the tool (L4).
const isToolPage = pathname => {
  const parts = segments(pathname);
  return parts[0] === 'tools' && parts.length > 1;
};

// L3: the page picks which column is filled; the order never changes.
const filledFor = pathname => {
  const page = segments(pathname)[0];
  if (page === 'blog' || page === 'early-access')
    return 'newsletter';
  return 'signup';
};

export const ladderFor = ({ pathname, signedIn }) => {
  // A page never repeats its own button: /pricing and /early-access have
  // their own Pro buttons, and the newsletter confirmation pages drop the
  // newsletter column.
  const page = segments(pathname)[0];
  let columns = LADDER_ORDER;
  if (page === 'pricing' || page === 'early-access')
    columns = columns.filter(column => column !== 'pro');
  else if (page === 'newsletter')
    columns = columns.filter(column => column !== 'newsletter');
  // L4: signed in, sign-up becomes "Go to OCL Online", except on a tool page,
  // where the column goes: the Get started block above already links there.
  if (signedIn)
    columns = isToolPage(pathname)
      ? columns.filter(column => column !== 'signup')
      : columns.map(column => (column === 'signup' ? 'openApp' : column));
  let primary = filledFor(pathname);
  if (primary === 'signup' && signedIn)
    primary = columns.includes('openApp') ? 'openApp' : 'pro';
  return { columns, primary };
};
